import { API } from '~apis/axios/instance';
import { PolicyModel } from '~models/policy';
import { ResponseBaseWithData } from '~types/response';

/**
 * 약관 데이터 조회
 * @link http://revenuemarket-apollo11-dev.eba-isum2qyp.ap-northeast-2.elasticbeanstalk.com/swagger-ui/index.html#/user-agreement-controller/getActiveAgreement
 * @returns
 */
export default function getAgreements() {
  return API.get<ResponseBaseWithData<PolicyModel.Agreement[]>>('/api/v2/agreements');
}
